import colors from "vuetify/es5/util/colors";

export default {
  primary: colors.blue.darken2, //#1976D2
  secondary: colors.grey.lighten2, //#E0E0E0
  accent: colors.blue.accent1, //#82B1FF
  error: colors.red.accent2, //#FF5252
  info: colors.blue, //#2196F3
  success: colors.green, //#4CAF50
  warning: colors.amber, //#FFC107
};
